<template>
  <Matrix v-if="conferenceStore.selected" />
  <div v-else class="loading-splash"><LoadingIcon /><span>Loading…</span></div>
</template>
<script setup>
import { onMounted } from "vue";
import Matrix from "@/components/parent/Matrix.vue";
import { useConferenceStore } from "@/stores/parent/conference";
import { useAgendaStore } from "@/stores/parent/agenda";
import { useSchoolStore } from "@/stores/school";
import { useRoute } from "vue-router";
import LoadingIcon from "@/assets/icons/loading.svg";

const conferenceStore = useConferenceStore();
const agendaStore = useAgendaStore();
useSchoolStore();
const route = useRoute();
async function initConferences() {
  if (route.params.id != null && conferenceStore.selected === null) {
    await conferenceStore.initializeStore(route.params.id);
  }
}
async function initAgenda() {
  if (route.params.id != null && conferenceStore.selected === null) {
    await agendaStore.fetchAgenda();
  }
}
// init()
onMounted(() => {
  initConferences().then(() => {
    console.log("Finished initializing conference data....");
  });
  initAgenda().then(() => {
    console.log("Finished initializing agenda data....");
  });
  console.log("Do we have a school");
  // if (schoolStore.school == null || schoolStore.school?.school_id == undefined) {
  // 	if (route.params.account != null && route.params.account != '') {
  // 		schoolStore.fetchSchool(route.params.account).then(result => { console.log("School found") });
  // 	} else {
  // 		window.location.href = 'https://www.ptcwizard.com';
  // 	}
  // }
});
</script>
